import { render, staticRenderFns } from "./InsectDetectionsEditor.vue?vue&type=template&id=78cffc2f&scoped=true&"
import script from "./InsectDetectionsEditor.vue?vue&type=script&lang=js&"
export * from "./InsectDetectionsEditor.vue?vue&type=script&lang=js&"
import style0 from "./InsectDetectionsEditor.vue?vue&type=style&index=0&id=78cffc2f&scoped=true&lang=sass&"
import style1 from "./InsectDetectionsEditor.vue?vue&type=style&index=1&id=78cffc2f&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78cffc2f",
  null
  
)

/* custom blocks */
import block0 from "./InsectDetectionsEditor.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78cffc2f')) {
      api.createRecord('78cffc2f', component.options)
    } else {
      api.reload('78cffc2f', component.options)
    }
    module.hot.accept("./InsectDetectionsEditor.vue?vue&type=template&id=78cffc2f&scoped=true&", function () {
      api.rerender('78cffc2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/InsectDetectionsEditor/InsectDetectionsEditor.vue"
export default component.exports